import { DataSources } from '~src/datasource/resources/Datasources';
import {getSessionManagementServiceInstance} from '~src/sessionManagement/SessionManagementService';

import { Messages } from '../../codegen/Localize';
import { IError } from '../../httpClient/serverApi/types/IError';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { CommonErrorCode } from '../../ts/helpers/ErrorCodes';
import { L10n } from '../../ts/L10n/L10n';
import { RefreshModeTypes } from '../../ts/ServerApi/types/IRemoteRefreshProperties';
import { ToasterService, ToastType } from '../../ts/services/ToasterService';
import { IDataSourceBase } from '../models/IDataSourceInfo';

export namespace ChangeDatasourceRefreshModeAction{
  export function execute(datasource: IDataSourceBase, newRefreshMode: string, currentRemoteAgentName: string, suppressErrorToast: boolean, suppressSuccessToast: boolean): Promise<IResult> {

    return DataSources.setRefreshMode(datasource.id, newRefreshMode).then((result: IResult) => {
      const sessionManagementService = getSessionManagementServiceInstance();
      if (!suppressErrorToast && result.errors && result.errors.length) {
        ToasterService.instance.pop({type: ToastType.Error, text: this.errorMessageFor(result.errors[0], datasource)});
      }

      if (!suppressSuccessToast && (!result.errors || !result.errors.length)) {
        if (newRefreshMode === RefreshModeTypes.Remote) {
          ToasterService.instance.pop({
            type: ToastType.Info,
            text: Messages.editRemoteRefreshPropertiesAgentSuccess({ AGENT_NAME: L10n.elideIfLong(currentRemoteAgentName) })
          });
        } else {
          if(sessionManagementService.isOnlineEnvironment()) {
            ToasterService.instance.pop({ type: ToastType.Info, text: Messages.editRemoteRefreshPropertiesServerSuccess() });
          }
        }
      }

      return result;
    });
  }

  // private errorMessageFor(error: IError, datasource: IDataSourceBase) {
  export function errorMessageFor(error: IError, datasource: IDataSourceBase) {
    switch (error.code) {
      case CommonErrorCode.DatasourceNotFound:
        return Messages.errorDatasourceNotFound ({ DATASOURCE_NAME: L10n.elideIfLong(datasource.name) });
      default:
        return Messages.errorUnknown();
    }
  }

}

export type ChangeDatasourceRefreshModeAction = typeof ChangeDatasourceRefreshModeAction;
